import { M365PulseApp } from "Core/M365PulseApp";
import { RootStoreProvider } from "Core/RootStoreProvider";
import { configure } from "mobx";
import { observer } from "mobx-react";
import React from "react";

const AppBase = () => (
    <RootStoreProvider>
        <M365PulseApp />
    </RootStoreProvider>
);

export const App = observer(AppBase);

configure({
    enforceActions: "never"
});
